import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TerminalCommand {
  private baseUrl: string = `${environment.apiUrl}/terminal-command`;
  private http: HttpClient = inject(HttpClient);

  isLoading = signal(false);
  errorMessage = signal('');
  response = signal<any>(null);

  sendCommand(serialNumber: string, command: string): void {
    this.isLoading.set(true);
    this.errorMessage.set('');
    this.response.set(null);

    this.http
      .post<any>(`${this.baseUrl}`, {
        serialNumber: serialNumber,
        command: command,
      })
      .subscribe({
        next: (data) => {
          this.response.set(data);
          this.isLoading.set(false);
        },
        error: (err) => {
          this.errorMessage.set(
            'Failed to send command' + ` Error: ${err.message}`,
          );
          this.isLoading.set(false);
        },
      });
  }
}
